import React from "react";

import { Dropdown, Text } from "components/ui/source";

import { SearchPricingFilter } from "types/graphql";

import { PriceRangeFilter } from "./PriceRangeFilter/PriceRangeFilter";

type PriceFiltersProps = {
  className?: string;
  data?: Partial<SearchPricingFilter>;
};

export function PriceFilters({ className, data = {} }: PriceFiltersProps) {
  return (
    <Dropdown
      className={className}
      height="sm"
      width="fit-content"
      buttonType="dropdown"
      noIcon
      label={
        <Text
          translateKey="filters.priceFilters.dropdown_label"
          types={["caption1", "bold", "inline"]}
        />
      }
      alignRight
      hasBorder
      outlineOnFocus
    >
      <PriceRangeFilter data={data} />
    </Dropdown>
  );
}
